module.exports = __webpack_public_path__ + "img/sysAnnouncementInfo.b18cb6c4.svg";